<template>
  <card-item card="item_guardian" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        {
          title: "Дети",
          component: () => import("./GuardianClient"),
                                       key:'childrens',
        },
        {
          title: "Адреса",
          component: () => import("./Address"),
                              key:'addresses',
        },
        {
          title: "Сменить пароль",
          component: () => import("./Password"),
                               key:'change_password',
        },
      ],
      activeTab: 0,
         infoKeys:[
        {
          key: 'full_name',
          title:'ФИО'
        },
        {
          key: 'phone',
          title:'Номер телефона'
        },
        ]
    };
  },
};
</script>